import DriverScreen from './components/DriverScreen'

export default {
  path: '/conductor',
  name: 'Driver',
  component: DriverScreen
}



// WEBPACK FOOTER //
// ./src/app/screens/Driver/index.js